import { ChevronRightIcon, PencilIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { HTMLProps, useEffect, useRef } from "react"
import Tooltip from "../Tooltip";
import openInNewTab from "../../../utils/openInNewTab";

export function IndeterminateCheckbox({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!)

  const primaryClasses = `checked:bg-primary-600 checked:focus:bg-primary-600 hover:checked:bg-primary-700
    indeterminate:bg-primary-600 hover:indeterminate:bg-primary-700
    focus:ring-primary-600 
  `;

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + ' p-3 cursor-pointer ' + primaryClasses}
      {...rest}
    />
  )
}

// {
//       id: 'select',
//       header: ({ table }: any) => (
//         <IndeterminateCheckbox
//           {...{
//             checked: table.getIsAllRowsSelected(),
//             indeterminate: table.getIsSomeRowsSelected(),
//             onChange: table.getToggleAllRowsSelectedHandler(),
//           }}
//         />
//       ),
//       cell: ({ row }: any) => (
//         <div className="flex justify-center items-center flex-1 p-1" onClick={(e) => e.stopPropagation()}>
//           <IndeterminateCheckbox
//             {...{
//               id: row.original.id,
//               checked: row.getIsSelected(),
//               disabled: !row.getCanSelect(),
//               indeterminate: row.getIsSomeSelected(),
//               onChange: row.getToggleSelectedHandler(),
//             }}
//           />
//           <button
//             onClick={(e) => { e.stopPropagation(); row.toggleExpanded(); }}
//             style={{ transform: `rotate(${!row.getIsExpanded() ? "0" : "-270"}deg)` }}
//             className="ml-3 p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200"
//           >
//             {/* {row.getIsExpanded() ? <ChevronDownIcon className="h-4 w-4" /> : <ChevronRightIcon className="h-4 w-4"/>} */}
//             <ChevronRightIcon className="h-4 w-4" />
//           </button>
//         </div>
//       ),
//     },

// return the above 
export default function TableCheckboxCol(showDropdown = true, showCheckbox = true, showEdit = false, editUrl = "", slim = false) {
  const iconSize = slim ? "h-3.5 w-3.5" : "h-4 w-4";
  const headerWrapperClasses = slim
    ? "flex items-center justify-center gap-1"
    : "flex justify-center items-center flex-1 gap-x-2 p-4";
  const cellWrapperClasses = slim
    ? "flex items-center justify-center gap-1"
    : "flex justify-center items-center flex-1 gap-x-2 p-1";
  const slimCheckboxClass = slim ? "!p-2" : "";
  const clearButtonBase = slim
    ? "rounded-full border border-gray-300 p-1 transition hover:bg-gray-100"
    : "p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200";
  const clearButtonEmpty = slim ? "pointer-events-none opacity-40" : "pointer-events-none";
  const clearButtonActive = slim
    ? "bg-primary-600 text-white hover:bg-primary-700"
    : "border-primary-700 bg-primary-600 hover:bg-primary-700 text-white";
  const dropdownButtonClasses = slim
    ? "rounded-full border border-gray-300 p-1 transition hover:bg-gray-100"
    : "p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200";

  return {
    id: 'select',
    ...(slim ? { meta: { thClassName: "!px-2 w-16", tdClassName: "!px-2 w-16" } } : {}),
    header: ({ table }: any) => showCheckbox ? (
      <div className={headerWrapperClasses}>
        <IndeterminateCheckbox
          className={slimCheckboxClass}
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
        <button
          type="button"
          onClick={() => { if (table.getState().rowSelection) table.resetRowSelection(); }}
          className={`${clearButtonBase} ${table.getSelectedRowModel().rows.length === 0 ? clearButtonEmpty : clearButtonActive}`}
        >
          <XMarkIcon className={iconSize} />
        </button>
      </div>
    ) : null,
    cell: ({ row }: any) => (
      <div className={cellWrapperClasses} onClick={(e) => e.stopPropagation()}>
        {showCheckbox && (
          <IndeterminateCheckbox
            className={slimCheckboxClass}
            {...{
              id: row.original.id,
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        )}

        <div className="flex flex-col gap-y-2">
          {showEdit && editUrl !== "" && (
            <Tooltip content="Edit Listing">
              <button
                onClick={() => { openInNewTab(`${editUrl}/${row.original.id}`) }}
                className={dropdownButtonClasses}
              >
                <PencilIcon className={iconSize} />
              </button>
            </Tooltip>
          )}

          {showDropdown &&
            <Tooltip content={row.getIsExpanded() ? "Close Details" : "Show Details"}>
              <button
                onClick={(e) => { e.stopPropagation(); row.toggleExpanded(); }}
                style={{ transform: `rotate(${!row.getIsExpanded() ? "0" : "-270"}deg)` }}
                className={dropdownButtonClasses}
              >
                <ChevronRightIcon className={iconSize} />
              </button>
            </Tooltip>
          }
        </div>


      </div>
    ),
  }
}